module.exports = __webpack_public_path__ + "static/img/2.010cf54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/sp/2.png
// module id = TbbJ
// module chunks = 0